import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
// import PinyinInput from "../../../components/ui/PinyinInput";
// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import * as Helper from "../../../../utils/Helper"

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/dictionary/letter/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import ImageField from "./ImageField";

const uid = UIDs.screens.admin.dictionary.letter.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_LETTERS_ASYNC]: {
                done: this._handleSaveLettersAsyncDone,
                error: this._handleAsyncActionError
            },
            [ActionTypes.BATCH_ADD_LETTERS_ASYNC]: {
                done: this._handleSaveLettersAsyncDone,
                error: this._handleAsyncActionError
            }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createLetters();
    }

    render() {
        const { letter } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!letter || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) || this.isActionExecuting(ActionTypes.SAVE_LETTERS_ASYNC) || this.isActionExecuting(ActionTypes.BATCH_ADD_LETTERS_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    navParams={this.localVars.navParams}
                                    letter={letter}
                                    onSave={this._handleSaveLetters}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveLetters = (data) => {
        const { id } = this.localVars.navParams;
        if (!id) {
            this.props.batchAddLettersAsync(data);
            return;
        }
        var imagesList = data.images;
        var images = imagesList && imagesList.length > 0 ? imagesList.join(";") : null;

        data.images = images;
        data.letterInfo = JSON.parse(data.letterInfo);

        var newSimilar = data.similar.replace(/\s/g, "");
        data.similar = newSimilar;

        /// throw error
        if (data.letterInfo.id === data.id && data.letterInfo.code === data.code) {
            this.props.saveLettersAsync(data);
        } else {
            console.log("error");
            this.displayError({ message: "You can't change the letter or code", code: 0 });
        }
        // confirmAlert({
        //     title: this.props.t("confirmToSave"),
        //     message: this.props.t("sureToDo"),
        //     buttons: [
        //         {
        //             label: this.props.t("yes"),
        //             onClick: () => {

        //             }
        //         },
        //         {
        //             label: this.props.t("no")
        //         }
        //     ]
        // });
    };

    _handleSaveLettersAsyncDone = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.dictionary.letter.list, this.localVars.navParams);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };
}

function EditForm(props) {
    const formMethods = useForm();
    const { letter } = props;
    const { id, code, pinyin, letterInfo, radicals, isPolyphone, level, similar, images, attribute } = letter;
    const { register, handleSubmit, errors, clearError } = formMethods;
    const submitRef = useRef();
    const [state_isPolyphone, setstate_isPolyphone] = useState(isPolyphone);

    const fieldsForImages = {
        choices: { name: "images", value: images ? images.split(";") : null},
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("letter")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            tag={Link}
                            to={{ pathname: NavigationService.getPathNameByUID(UIDs.screens.admin.dictionary.letter.list), state: props.navParams }}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("id")}</label>
                                    <textarea rows="3" disabled={!!id} name="id" type="text"
                                        className="form-control-alternative form-control" defaultValue={id}
                                        ref={register({ required: true })} />
                                    {errors.id && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                    {/* <PinyinInput inputClassName={"form-control-alternative form-control"}/> */}
                                </div>
                            </div>
                        </div>
                        <div className="row" hidden={!id}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("code")}</label>
                                    <input disabled name="code" className="form-control-alternative form-control"
                                        defaultValue={code}
                                        ref={register} />
                                    {errors.code && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row" hidden={!id}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("pinyin")}</label>
                                    <input name="pinyin" className="form-control-alternative form-control"
                                           defaultValue={pinyin}
                                           ref={register}/>
                                    {errors.pinyin && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("attribute")}</label>
                                    <select name="attribute" ref={register} className="form-control-alternative form-control">
                                        <option value="" selected = {attribute ? true : false}>{props.t("attribute0")}</option>
                                        <option value={"a"} selected = {attribute === "a"}>{props.t("attributea")}</option>
                                        <option value={"b"} selected = {attribute === "b"}>{props.t("attributeb")}</option>
                                        <option value={"c"} selected = {attribute === "c"}>{props.t("attributec")}</option>
                                        <option value={"d"} selected = {attribute === "d"}>{props.t("attributed")}</option>
                                        <option value={"e"} selected = {attribute === "e"}>{props.t("attributee")}</option>
                                        <option value={"f"} selected = {attribute === "f"}>{props.t("attributef")}</option>
                                        <option value={"g"} selected = {attribute === "g"}>{props.t("attributeg")}</option>
                                        <option value={"h"} selected = {attribute === "h"}>{props.t("attributeh")}</option>
                                        <option value={"i"} selected = {attribute === "i"}>{props.t("attributei")}</option>
                                        <option value={"j"} selected = {attribute === "j"}>{props.t("attributej")}</option>
                                        <option value={"k"} selected = {attribute === "k"}>{props.t("attributek")}</option>
                                        <option value={"l"} selected = {attribute === "l"}>{props.t("attributel")}</option>
                                        <option value={"m"} selected = {attribute === "m"}>{props.t("attributem")}</option>
                                        <option value={"n"} selected = {attribute === "n"}>{props.t("attributen")}</option>
                                        <option value={"o"} selected = {attribute === "o"}>{props.t("attributeo")}</option>
                                        <option value={"p"} selected = {attribute === "p"}>{props.t("attributep")}</option>
                                        <option value={"q"} selected = {attribute === "q"}>{props.t("attributeq")}</option>
                                        <option value={"r"} selected = {attribute === "r"}>{props.t("attributer")}</option>
                                        <option value={"s"} selected = {attribute === "s"}>{props.t("attributes")}</option>
                                        <option value={"t"} selected = {attribute === "t"}>{props.t("attributet")}</option>
                                        <option value={"u"} selected = {attribute === "u"}>{props.t("attributeu")}</option>
                                        <option value={"v"} selected = {attribute === "v"}>{props.t("attributev")}</option>
                                        <option value={"w"} selected = {attribute === "w"}>{props.t("attributew")}</option>
                                        <option value={"x"} selected = {attribute === "x"}>{props.t("attributex")}</option>
                                        <option value={"y"} selected = {attribute === "y"}>{props.t("attributey")}</option>
                                        <option value={"z"} selected = {attribute === "z"}>{props.t("attributez")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row" hidden={!id}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("radical")}</label>
                                    <input name="radicals" className="form-control-alternative form-control"
                                        defaultValue={radicals}
                                        ref={register} />
                                    {errors.radicals && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row" hidden={!id}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("polyphone")}</label>
                                    <select
                                        className="form-control-alternative form-control"
                                        name="isPolyphone"
                                        defaultValue={state_isPolyphone}
                                        onClick={(e) => { setstate_isPolyphone(e.target.value) }}
                                        ref={register({
                                            required: props.t("fieldIsRequired")
                                        })}>
                                        <option value="false">{props.t("no")}</option>
                                        <option value="true">{props.t("yes")}</option>
                                    </select>
                                    {errors.isPolyphone && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("level")}</label>
                                    <select name="level" ref={register} className="form-control-alternative form-control">
                                        <option value="" selected = {level ? true : false}>{props.t("level0")}</option>
                                        <option value={1} selected = {level === 1}>1</option>
                                        <option value={2} selected = {level === 2}>2</option>
                                        <option value={3} selected = {level === 3}>3</option>
                                        <option value={4} selected = {level === 4}>4</option>
                                        <option value={5} selected = {level === 5}>5</option>
                                        <option value={6} selected = {level === 6}>6</option>
                                        <option value={789} selected = {level === 789}>{props.t("level789")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {code ? <ImageField formMethods={formMethods} fields={fieldsForImages} choiceNum="3" /> : null}
                        <div className="row" hidden={!id} style={{marginTop:20}}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("similar")}</label>
                                    <input name="similar" className="form-control-alternative form-control"
                                        defaultValue={similar}
                                        maxLength={10}
                                        ref={register({
                                            validate: {
                                                message: (value) => Helper.isNullOrEmpty(value) ? clearError() : (Helper.isChinese(value.replace(/\s/g, "")) ? clearError() : props.t("onlyChinese")),
                                            },
                                        })} />
                                    {errors.similar && <span className="text-danger">{errors.similar.message}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row" hidden={!id}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("letterInfo")}</label>
                                    <textarea disabled={!id} name="letterInfo" rows="10"
                                        className="form-control-alternative form-control"
                                        defaultValue={JSON.stringify(letterInfo, "", "\t")}
                                        ref={register} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: letter => dispatch(Actions.loadScreenViewAsync(letter)),
        saveLettersAsync: vo => dispatch(Actions.saveLettersAsync(vo)),
        createLetters: () => dispatch(Actions.createLetters()),
        batchAddLettersAsync: vo => dispatch(Actions.batchAddLettersAsync(vo))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
